import CardHeaderAvatar from './card-header-avatar';

export default CardHeaderAvatar;
